import { useState, useEffect } from "react";
import { User, AIPlayer, Playline, Stock } from "./components";
import { PageContainer } from "./components/styled";

const App = () => {
  const [dimensions, setDimensions] = useState({
    w: document.documentElement.clientWidth,
    h: document.documentElement.clientHeight,
  });

  const handleResize = () => {
    setDimensions({
      w: document.documentElement.clientWidth,
      h: document.documentElement.clientHeight,
    });
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <PageContainer
      style={(() => {
        var width = dimensions.w;
        var height = dimensions.h;
        var ratio = (height / width).toFixed(1);
        var scale;
        if (ratio <= 1.6) {
          scale = height / 800;
        } else {
          scale = width / 440;
        }
        return { transform: "scale(".concat(scale, ")") };
      })()}
    >
      <Stock />
      <AIPlayer />
      <Playline />
      <User />
    </PageContainer>
  );
};

export default App;
